// extracted by mini-css-extract-plugin
export var adv = "style-module--adv--9bd0e";
export var container = "style-module--container--4cdd4";
export var develop = "style-module--develop--1e369";
export var experts = "style-module--experts--890ce";
export var gray = "style-module--gray--a0661";
export var orange = "style-module--orange--52e57";
export var partners = "style-module--partners--bd9ce";
export var violet = "style-module--violet--14e2e";